import RouteNavigator from "../Routes/RouteNavigator";


export default function Pages() {
  return (
      <RouteNavigator />
  );
}
